(function() {
	document.addEventListener("DOMContentLoaded", function() {

		var signIn = document.getElementById("signInItem");

		var loginHeaderForm = document.getElementById("loginHeaderForm");
		var messageHeaderForm = document.getElementById("messageHeaderForm");
		var errorsHeaderForm = document.getElementById("errorsHeaderForm");

		var noneClass = "display_none";
		var closeClass = "headerForm__close";

		if(signIn && loginHeaderForm) {
			loginHeaderForm.classList.add(noneClass);

			signIn.addEventListener("click", function(event) {
				event = event || window.event;
				event.preventDefault();

				loginHeaderForm.classList.toggle(noneClass);
			});
		}

		if(loginHeaderForm && errorsHeaderForm && !errorsHeaderForm.classList.contains(noneClass))
			loginHeaderForm.classList.remove(noneClass);

		if(messageHeaderForm) {
			messageHeaderForm.addEventListener("click", function(event) {
				event = event || window.event;
				var target = event.target;

				if(target.classList.contains(closeClass)) closeHeaderMessage(this);

			});
		}

		if(errorsHeaderForm) {
			errorsHeaderForm.addEventListener("click", function(event) {
				event = event || window.event;
				var target = event.target;

				if(target.classList.contains(closeClass)) closeHeaderMessage(this);

			});
		}

		function closeHeaderMessage(elem) {
			elem.parentElement.removeChild(elem);
		}

	});
})();